import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ClassificationField } from "../../../../../../models/classification-field";
import { ClassificationGroup } from "../../../../../../models/classification-group";
import { SelectOperatorType } from "../../../../../../models/select-operator";
import { ClassificationControllerService } from "../../../../../../services/classifications-controller/classification-controller.service";
import { ClassificationGroupControllerService } from "../../../../../../services/classifications-controller/classification-group-controller.service";
import { SelectSubjectType } from "../../../../../../models/select-subject";
import { FieldType } from "../../../../../../models/field-type";
import { BaseFieldDeterminantComponent } from "./base-field-determinant.component";
import { date } from "ngx-custom-validators/src/app/date/validator";
import { map } from 'rxjs/operators';

@Component({
  selector: "catalog-determinant",
  templateUrl: "./catalog-determinant.component.html",
  styles: [],
})
export class CatalogDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  @Input() public isTargetComponent: boolean;
  public subjects: string[];
  @Input() public catalogFieldValue: ClassificationField;
  @Input() public classificationFields: ClassificationField[] = [];
  @Input() public catalogId: string;
  @Input() public parentCatalogTypeId: string;
  @Input() public type: FieldType;
  @Input() public gdbCatalog: any;
  @Input() public catalogGroupId: string;
  @Input() public operator: any = "EQUAL";
  public catalogFields: ClassificationField[] = [];
  @Input() public determinantType: string;
  @Output() public catalogValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();
  @Output() public changeClassificationFields = new EventEmitter();
  @Output() public catalogGroupValueChanged = new EventEmitter();
  @Input() public catalogFieldValueId: any;
  @Input() public catalogGroupValue: string;
  @Input() public fields: any[] = [];
  @Input() public sourceFormFieldKey: string;
  @Input() public subject: SelectSubjectType;
  @Input() public catalogGroupFields: ClassificationGroup[] = [];
  @Output() public subjectResponse = new EventEmitter();
  @Input() public targetFormFieldKey: any;
  @Input() public isCatalogMultiple: boolean = false;
  public gdbCatalogProperties: any;

  constructor(private classificationControllerService: ClassificationControllerService,
    private classificationGroupService: ClassificationGroupControllerService,
    public toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    // if not GUIDE determinant or id EDIT GUIDE determinant
    // if (this.determinantType !== DeterminantType.QUESTION.toString() || this.catalogFieldValue) {
    //  this.operators = Object.keys(ClassificationOperatorType);
    // }  else {
    // if new catalogue question type determinant (can be both classification and grouping)
    this.subjects = Object.keys(SelectSubjectType);
    this.operators = Object.keys(SelectOperatorType);
    // console.log(this.fields, this.type);
    this.operators = this.operators.filter((o) => !String(o.toLocaleLowerCase).includes("in"));
    this.fields = this.fields.filter((f) => {
      return f.type === "select" && !f.multiple;
    });
    console.log(this.catalogFieldValue, this.classificationFields, this.catalogId, this.parentCatalogTypeId, this.type, this.catalogGroupId, this.operator, this.operators, this.catalogFieldValueId);
    // }

    console.log("subject is", this.subject);
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    // this.catalogFieldValueId = null;
    // this.catalogFields = [];
    console.log(changes);
    if (!this.operators?.length) {
      this.operators = Object.keys(SelectOperatorType);
    }
    if (changes.catalogId && changes.catalogId.currentValue) {
      this.catalogId = changes.catalogId.currentValue;
    }
    if (changes.catalogFieldValue && changes.catalogFieldValue.currentValue) {
      this.catalogFieldValueId = changes.catalogFieldValue.currentValue.id;
    }
    if (changes.catalogGroupId && changes.catalogGroupId.currentValue) {
      this.catalogGroupId = changes.catalogGroupId.currentValue;
    }
    /*if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.inputType === "CLASSIFICATION"));
    }*/
    if ((changes.gdbCatalog && changes.gdbCatalog.currentValue) || this.gdbCatalog) {
      this.gdbCatalog = changes.gdbCatalog?.currentValue || this.gdbCatalog;
      this.loadGDBcatalogProperties();
    } else {
      this.loadCatalogFields();
      this.loadCatalogGroups();
    }

    super.ngOnChanges(changes);
  }

  public loadCatalogFields() {
    console.log(this.catalogId, this.catalogFieldValue?.classificationTypeId);
    if (this.catalogId || this.catalogFieldValue?.classificationTypeId) {
      this.loadCatalogFieldsFilteredByGroup();
    } else {
      this.catalogFields = [];
    }
  }

  public loadGDBcatalogProperties() {
    this.classificationControllerService.getClassificationsGDB().subscribe(
      (data: any) => {
        this.gdbCatalogProperties = data.filter((f) => f.id === this.gdbCatalog.gdbCatalog)[0];
        console.log("--- loadGDBcatalogProperties", this.gdbCatalogProperties, this.gdbCatalog);
        if (this.gdbCatalogProperties) {
          this.loadGDBCatalogFields();
        } else {
          this.showErrorMessageWithTitle("Error when loading GDB databases", "GDB database not found: " + this.gdbCatalog.gdbCatalog);
        }
      },
      (error) => this.showErrorMessageWithTitle("Error when loading GDB databases", error),
    );
  }

  public loadGDBCatalogFields() {
    this.catalogFields = [];
    const fieldId = this.gdbCatalog.gdbCatalogValue.fieldId.split(".")[0];
    this.classificationControllerService.getClassificationsGDBvalue(this.gdbCatalogProperties.dbVersion, this.gdbCatalogProperties.dbCode, fieldId).subscribe(
      (data: any) => {
        console.log(data);
        this.catalogFields = data.map((item) => {
          const newItem = {
            id: "",
            key: "",
            value: "",
          };
          if (typeof item === "string") {
            if (item.length > 0) { newItem.id = item; }
            newItem.key = item;
            newItem.value = item;
            return newItem;
          } else {
            newItem.id = item.key;
            newItem.key = item.key;
            newItem.value = item.value;
            return newItem;
          }
        });
        // console.log(data, this.catalogFields, this.catalogFieldValueId);
        if (typeof this.catalogFieldValueId === "string") {
          this.catalogFieldValueId = this.catalogFields.find((f) => f.id === this.catalogFieldValueId || f.key === this.catalogFieldValueId || f.value === this.catalogFieldValueId)?.id;
        }
        // console.log("--- this.catalogFieldValueId", this.catalogFieldValueId);
      },
      (error) => this.showErrorMessageWithTitle("Error when loading GDB catalog field values", error),
    );
  }

  public loadCatalogGroups() {
    if (this.catalogId || this.catalogFieldValue?.classificationTypeId) {
      this.classificationGroupService.getClassificationsGroupsByType(this.catalogId || this.catalogFieldValue?.classificationTypeId).subscribe(
        (data) => {
          this.catalogGroupFields = data;
          this.filterOperators();
        },
        (error) => this.showErrorMessageWithTitle("Error when loading catalog groups", error),
      );
    } else if (this.parentCatalogTypeId) {
      this.classificationGroupService.getClassificationsGroupsByParentType(this.parentCatalogTypeId).subscribe(
        (data) => {
          this.catalogGroupFields = data;
          this.filterOperators();
        },
        (error) => this.showErrorMessageWithTitle("Error when loading catalog groups", error),
      );
    } else {
      this.catalogGroupFields = [];
      this.filterOperators();
    }
  }

  public filterSubjects(operator: string): SelectSubjectType[] {
    switch (operator) {
      case "EQUAL":
        return [SelectSubjectType.NONE, SelectSubjectType.SOME];
      case "NOT_EQUAL":
        return [SelectSubjectType.ALL, SelectSubjectType.SOME];
      case "IN":
      case "NOT_IN":
      default:
        return [SelectSubjectType.ALL, SelectSubjectType.NONE, SelectSubjectType.SOME];
    }
  }

  public filterOperators() {
    // console.log(this.catalogGroupFields, this.operators);
    if (!this.catalogGroupFields.length && this.operators) {
      this.operators = this.operators.filter((f) => f.toLowerCase() !== "in" && f.toLowerCase() !== "not_in");
    } else {
      this.type = FieldType.GROUPING;
      this.operators = Object.keys(SelectOperatorType);
      this.operators = this.operators.filter((o) => !String(o.toLocaleLowerCase).includes("in"));
    }
    this.checkOperators();
  }

  private loadCatalogFieldsFilteredByGroup() {

    this.classificationControllerService.getClassificationsByType(this.catalogId || this.catalogFieldValue?.classificationTypeId).subscribe(
      (data) => {
        console.log(data);
        this.catalogFields = [];
        data.forEach((item) => {
          if (this.catalogGroupId) {
            const found = item.classificationGroups.some((r) => r.id === this.catalogGroupId);
            if (found) {
              this.catalogFields.push(item);
            }
          } else {
            this.catalogFields.push(item);
          }
        });
      },
      (error) => this.showErrorMessageWithTitle("Error when loading catalogs", error),
    );
  }

  public selectValueChanged(newValue: any) {
    console.log("selectValueChanged", newValue, this.catalogFieldValueId);
    if (newValue && newValue !== this.catalogFieldValueId) {
      this.catalogFields.forEach((item) => {
        if (item != null && item.id === newValue) {
          this.catalogValueResponse.emit({ catalogValue: item });
        }
      });
    } else {
      if (newValue !== this.catalogFieldValueId) {
        this.catalogFieldValueId = null;
        this.catalogValueResponse.emit({ catalogValue: null });
      }
    }
  }

  public selectGroupChanged(newValue: string) {
    if (newValue) {
      this.catalogGroupFields.forEach((item) => {
        if (item != null && item.id === newValue) {
          this.catalogGroupValueChanged.emit(item);
        }
      });
    } else {
      this.catalogGroupValue = null;
      this.catalogGroupValueChanged.emit(null);
    }
  }

  public updateClassificationFields(multipleFields) {
    console.log("--- updateClassificationFields", multipleFields);
    this.changeClassificationFields.emit(multipleFields.map((field) => field.id));
  }

  public operatorValueChanged() {
    // here we need to change subject
    this.operatorResponse.emit(this.operator);
    this.subject = this.filterSubjects(this.operator)[0];
    console.log("operator value changed ");
    this.subjectValueChanged();
  }

  public subjectValueChanged() {
    this.subjectResponse.emit(this.subject);
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.catalogValueResponse.emit({ sourceFormFieldKey: this.sourceFormFieldKey });
  }
}
